// 全景图预加载服务
class PreloadService {
  constructor() {
    this.preloadedImages = new Map();
    this.isPreloading = false;
    this.preloadPromise = null;
  }

  // 预加载所有全景图
  preloadAllPanoramas() {
    // 如果已经在预加载，返回现有的 Promise
    if (this.preloadPromise) {
      return this.preloadPromise;
    }

    this.isPreloading = true;

    const OSS_BASE_URL = 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets';
    
    // 12 张全景图的 URL
    const panoramaUrls = Array.from({ length: 12 }, (_, i) => 
      `${OSS_BASE_URL}/${i + 1}.jpg`
    );

    // 优先加载前 3 张
    const priorityUrls = panoramaUrls.slice(0, 3);
    const otherUrls = panoramaUrls.slice(3);

    // 先加载优先级高的图片
    const priorityPromises = priorityUrls.map((url, index) => 
      this.preloadImage(url, 'high', index + 1)
    );

    this.preloadPromise = Promise.all(priorityPromises).then(() => {
      // 然后加载其他图片
      const otherPromises = otherUrls.map((url, index) => 
        this.preloadImage(url, 'low', index + 4)
      );
      
      return Promise.all(otherPromises);
    }).then(() => {
      this.isPreloading = false;
    }).catch(error => {
      console.error('预加载出错:', error);
      this.isPreloading = false;
    });

    return this.preloadPromise;
  }

  // 预加载单张图片并转换为 Blob URL
  preloadImage(url, priority = 'low') {
    // 如果已经加载过，直接返回
    if (this.preloadedImages.has(url)) {
      return Promise.resolve(this.preloadedImages.get(url));
    }

    return new Promise((resolve) => {
      fetch(url, {
        priority: priority === 'high' ? 'high' : 'low',
        cache: 'force-cache'
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        // 创建 Blob URL
        const blobUrl = URL.createObjectURL(blob);
        
        // 保存到缓存
        this.preloadedImages.set(url, {
          blobUrl: blobUrl,
          blob: blob,
          originalUrl: url
        });
        
        resolve(blobUrl);
      })
      .catch(error => {
        console.warn(`预加载失败: ${url.split('/').pop()}`, error);
        // 失败时返回原始 URL
        resolve(url);
      });
    });
  }

  // 获取预加载的图片
  getPreloadedImage(url) {
    return this.preloadedImages.get(url);
  }

  // 检查图片是否已预加载
  hasPreloaded(url) {
    return this.preloadedImages.has(url);
  }

  // 获取所有预加载的图片
  getAllPreloadedImages() {
    return this.preloadedImages;
  }

  // 清理所有 Blob URL
  cleanup() {
    this.preloadedImages.forEach(cached => {
      if (cached.blobUrl) {
        URL.revokeObjectURL(cached.blobUrl);
      }
    });
    this.preloadedImages.clear();
  }
}

// 创建单例
const preloadService = new PreloadService();

export default preloadService;
